import { CapturedVideoData } from 'lib/clients/mediaRecorder';
import { CameraInspectionData } from 'verify/lib/interfaces/cameraInspection';
import { CaptureMethod } from 'verify/models/verification';

export enum SelfieStep {
  Center = 'center',
  Left = 'left',
  Right = 'right',
}

export type SelfiePoseOrder = [SelfieStep.Center] | SelfieThreePointPoseOrder;

export type SelfieThreePointPoseOrder =
  | [SelfieStep.Center, SelfieStep.Left, SelfieStep.Right]
  | [SelfieStep.Center, SelfieStep.Right, SelfieStep.Left];

export type CapturedSelfie = {
  capturedAt?: string;
  captureMethod: CaptureMethod;
  dataUrl: string;
  pose: SelfieStep;
};

// The captured selfies and all relevant metadata we want to submit
export type CapturedSelfiesSubmitData = {
  cameraInspectionData?: CameraInspectionData;
  capturedSelfies: CapturedSelfie[];
  capturedVideoData?: CapturedVideoData;
  captureStartedAt?: string | null;
};
